import React from "react";
import {withRouter} from "react-router-dom";
import './PageRegister.css';
import {Mutation} from "react-apollo";
import {SIGNUP_USER} from "../../../queries";
import { GIVE_PROPERTY_UNITES } from "../../../../../../Adminka/client/src/queries";
import ButtonStandart from "../../Elements/Buttons/ButtonStandart/ButtonStandart";
import { menuText } from "./RegisterLang";

import russia from "../../../img/MainMenu/russia.png";
import germany from "../../../img/MainMenu/germany.png";
import unitedkingdom from "../../../img/MainMenu/united-kingdom.png";
import china from "../../../img/MainMenu/china.png";
import korea from "../../../img/MainMenu/korea.png";
import france from "../../../img/MainMenu/france.png";

import italy from "../../../img/MainMenu/italy.png";
import japan from "../../../img/MainMenu/japan.png";
import portugal from "../../../img/MainMenu/portugal.png";
import spain from "../../../img/MainMenu/spain.png";
import turkey from "../../../img/MainMenu/turkey.png";
import vietnam from "../../../img/MainMenu/vietnam.png";
import oae from "../../../img/MainMenu/oae.png";
import downward from "../../../img/MainMenu/downward-arrow.png";

class PageRegister extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            SITE_ADDRESS: "https://launch.artyfact.game",
            Agent : this.props.Agent ? this.props.Agent : '',
            Name : '',
            Surname : '',
            email : '',
            password : '',
            passwordConfirmation : '',
            MobilePhone : '',
            BSCWallet: '',
            StatusMain: 'Guest',
            DepositCheck: false,
            DataCheck: false,
            ButtonActiveBuy: false,
            ButtonActiveBuy2: false,
            ErrName: false,
            ErrSurname: false,
            ErrEmail: false,
            ErrPass: false,
            ErrPassConf: false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
            showLangMenu: false,
        };
    };

    componentDidMount() {
        let client = window.navigator ? (window.navigator.language ||
			window.navigator.systemLanguage ||
			window.navigator.userLanguage) : ("en-US");

		let language = (client.search('-') > 0) ?
			client.substring(0, client.search('-')).toLowerCase() :
			client.toLowerCase();

		// let country = (client.search('-') > 0) ?
		// 	client.substring(client.search('-') + 1, client.length).toLowerCase() :
		// 	config.country;

		if (!localStorage.getItem('lang') && language == 'ru') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : language});
		}

		if (!localStorage.getItem('lang') && language == 'fr') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : language});
		}

		if (!localStorage.getItem('lang') && language == 'de') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : language});
		}

		if (!localStorage.getItem('lang') && language == 'en') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "en");
            this.setState({Language : "en"});
		}

        if (!localStorage.getItem('lang') && language == 'zh') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "ch");
            this.setState({Language : "ch"});
		}

		if (!localStorage.getItem('lang') && language == 'ko') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : "ko"});
		}
		
		if (!localStorage.getItem('lang') && language == 'it') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : "it"});
		}
		
		if (!localStorage.getItem('lang') && language == 'jа') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "jap");
            this.setState({Language : "jap"});
		}
		
		if (!localStorage.getItem('lang') && language == 'pt') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "port");
            this.setState({Language : "port"});
		}
		
		if (!localStorage.getItem('lang') && language == 'tr') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "turk");
            this.setState({Language : "turk"});
		}
		
		if (!localStorage.getItem('lang') && language == 'vi') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "viet");
            this.setState({Language : "viet"});
		}
		
		if (!localStorage.getItem('lang') && language == 'es') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "spa");
            this.setState({Language : "spa"});
		}
		
		if (!localStorage.getItem('lang') && language == 'ar') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "arab");
            this.setState({Language : "arab"});
		}
    }

    ChangeSignUpInput = event => {
        const  {name, value} = event.target;
        //console.log(name, ":", value)
        this.setState(() => ({ [name] : value}));
    };

    ChangeSignUpInputEmail = event => {
        const  {name, value} = event.target;
        //console.log(name, ":", value)
        this.setState(() => ({ [name] : value.toLowerCase() }));
    };

    SubmitSignUp = (event, signupUser) => {
        event.preventDefault();
        signupUser().then(async ({ data }) => {
            console.log({ data });
            localStorage.setItem('token',data.signupUser.token);
            await this.props.refetch();
            window.open(this.state.SITE_ADDRESS, '_top');
            //this.props.history.push('/');
            //location.reload();
        });
    };

    SignUpValidate = (event, signupUser) => {
        const { email, password, passwordConfirmation, BSCWallet } = this.state;
        const isInvalid = !email || !BSCWallet || !password || !passwordConfirmation || password !== passwordConfirmation;
        return isInvalid
    };

    ChangeElementCheck1 = event => {
        let check1 = document.getElementById("DepositCheck").checked;
        // let check2 = document.getElementById("DataCheck").checked;
        this.setState({ DepositCheck: document.getElementById("DepositCheck").checked });
        if (check1) { // && check2
            this.setState({ ButtonActiveBuy2: true });
        } else {
            this.setState({ ButtonActiveBuy2: false });
        }
        /*const { email, password, passwordConfirmation, BSCWallet } = this.state;
        const isInvalid = !email || !BSCWallet || !password || !passwordConfirmation || password !== passwordConfirmation;
        if (!isInvalid) {
            this.setState({ ButtonActiveBuy: true });
        } else {
            this.setState({ ButtonActiveBuy: false });
        }*/
    }

    ChangeElementCheck2 = event => {
        let check1 = document.getElementById("DepositCheck").checked;
        // let check2 = document.getElementById("DataCheck").checked;
        this.setState({ DataCheck: document.getElementById("DataCheck").checked });
        if (check1) { // && check2
            this.setState({ ButtonActiveBuy2: true });
        } else {
            this.setState({ ButtonActiveBuy2: false });
        }
        /*const { email, password, passwordConfirmation, BSCWallet } = this.state;
        const isInvalid = !email || !BSCWallet || !password || !passwordConfirmation || password !== passwordConfirmation;
        if (!isInvalid) {
            this.setState({ ButtonActiveBuy: true });
        } else {
            this.setState({ ButtonActiveBuy: false });
        }*/
    }

    changeLangButton = event => {
        event.preventDefault();
        const showLang = this.state.showLangMenu;
        this.setState({ showLangMenu: !showLang });
    }

    changeLanguage = (event, lang) => {
        localStorage.setItem('language', lang);
        // console.log(localStorage.getItem('language'));
        this.setState({Language : lang});
        const showLang = this.state.showLangMenu;
        this.setState({ showLangMenu: !showLang });
    }

    render() {
        const { Name, Surname, password, passwordConfirmation, email, StatusMain, MobilePhone, Agent, BSCWallet} = this.state;
        return (
            <div className="SignUp">
                <div className="login-ttl flex-login-ttl">{menuText.create_account[this.state.Language]}
                    <details class="dropdown" style={{ display: "inline-block"}} open={this.state.showLangMenu ? true : false}>
                        <summary role="button" onClick={event => this.changeLangButton(event)}>
                            <a class="button">
                                {this.state.Language == 'en' &&
                                    <img width="20px" src={unitedkingdom}/>
                                }
                                {this.state.Language == 'de' &&
                                    <img width="20px" src={germany}/>
                                }
                                {this.state.Language == 'fr' &&
                                    <img width="20px" src={france}/>
                                }
                                {this.state.Language == 'ko' &&
                                    <img width="20px" src={korea}/>
                                }
                                {this.state.Language == 'ch' &&
                                    <img width="20px" src={china}/>
                                }
                                {this.state.Language == 'ru' &&
                                    <img width="20px" src={russia}/>
                                }
                                {this.state.Language == 'it' &&
                                    <img width="20px" src={italy}/>
                                }
                                {this.state.Language == 'jap' &&
                                    <img width="20px" src={japan}/>
                                }
                                {this.state.Language == 'port' &&
                                    <img width="20px" src={portugal}/>
                                }
                                {this.state.Language == 'turk' &&
                                    <img width="20px" src={turkey}/>
                                }
                                {this.state.Language == 'viet' &&
                                    <img width="20px" src={vietnam}/>
                                }
                                {this.state.Language == 'spa' &&
                                    <img width="20px" src={spain}/>
                                }
                                {this.state.Language == 'arab' &&
                                    <img width="20px" src={oae}/>
                                }
                                <img className="ml5px" width="15px" src={downward}/>
                            </a>
                        </summary>
                        <ul>
                            {this.state.Language != 'en' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'en')} style={{ cursor: 'pointer' }} src={unitedkingdom}/></li>}
                            {this.state.Language != 'de' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'de')} style={{ cursor: 'pointer' }} src={germany}/></li>}
                            {this.state.Language != 'fr' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'fr')} style={{ cursor: 'pointer' }} src={france}/></li>}
                            {this.state.Language != 'ko' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'ko')} style={{ cursor: 'pointer' }} src={korea}/></li>}
                            {this.state.Language != 'ch' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'ch')} style={{ cursor: 'pointer' }} src={china}/></li>}
                            {this.state.Language != 'ru' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'ru')} style={{ cursor: 'pointer' }} src={russia}/></li>}
                            {this.state.Language != 'it' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'it')} style={{ cursor: 'pointer' }} src={italy}/></li>}
                            {this.state.Language != 'jap' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'jap')} style={{ cursor: 'pointer' }} src={japan}/></li>}
                            {this.state.Language != 'port' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'port')} style={{ cursor: 'pointer' }} src={portugal}/></li>}
                            {this.state.Language != 'turk' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'turk')} style={{ cursor: 'pointer' }} src={turkey}/></li>}
                            {this.state.Language != 'viet' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'viet')} style={{ cursor: 'pointer' }} src={vietnam}/></li>}
                            {this.state.Language != 'spa' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'spa')} style={{ cursor: 'pointer' }} src={spain}/></li>}
                            {this.state.Language != 'arab' &&
                            <li><img width="24px" onClick={event => this.changeLanguage(event, 'arab')} style={{ cursor: 'pointer' }} src={oae}/></li>}
                        </ul>
                    </details>
                </div>
                <Mutation mutation={SIGNUP_USER} variables={{ Name, Surname, email, password, MobilePhone, StatusMain, Agent, BSCWallet}}>
                    {(signupUser,{data, loading, error}) => {
                        return(
                            <form className="SignUpform" onSubmit={event => this.SubmitSignUp(event, signupUser)}>
                                <div className="ForgotInput">
                                    <label>
                                        <input type="text" name="Name" required placeholder="&nbsp;" value={Name} onChange={this.ChangeSignUpInput} />
                                        <span className="TextPlaceHolder">{menuText.name[this.state.Language]}*</span>
                                    </label>                                    
                                </div>
                                <div className="ForgotInput">
                                    <label>
                                        <input type="text" name="Surname" required placeholder="&nbsp;" value={Surname} onChange={this.ChangeSignUpInput} />
                                        <span className="TextPlaceHolder">{menuText.surname[this.state.Language]}*</span>
                                    </label>                                   
                                </div>
                                <div className="ForgotInput">
                                    <label>
                                        <input type="email" name="email" required placeholder="&nbsp;" value={email} onChange={this.ChangeSignUpInputEmail} />   
                                        <span className="TextPlaceHolder">{menuText.email[this.state.Language]}*</span>
                                    </label>
                                </div>
                                <div className="ForgotInput">
                                    <label>
                                        <input type="text" name="BSCWallet" required placeholder="&nbsp;" value={BSCWallet} onChange={this.ChangeSignUpInput} />   
                                        <span className="TextPlaceHolder">{menuText.bep20[this.state.Language]}*</span>
                                    </label>
                                </div>
                                {/*<div className="ForgotInput">
                                    <label>
                                        <input type="text" name="MobilePhone" placeholder="&nbsp;" value={MobilePhone} onChange={this.ChangeSignUpInput} />
                                        <span className="TextPlaceHolder">Phone number</span>
                                    </label>
                                </div>*/}
                                <div className="ForgotInput">
                                    <label>
                                        <input type="password" name="password" required placeholder="&nbsp;" value={password} onChange={this.ChangeSignUpInput} />
                                        <span className="TextPlaceHolder">{menuText.password[this.state.Language]}*</span>
                                    </label>
                                </div>
                                <div className="ForgotInput">
                                    <label>
                                        <input type="password" name="passwordConfirmation" required placeholder="&nbsp;" value={passwordConfirmation} onChange={this.ChangeSignUpInput} />
                                        <span className="TextPlaceHolder">{menuText.confirm_password[this.state.Language]}*</span>
                                    </label>
                                </div>  
                                <div className="VerificationBlockFormThirdLabelCheck VerificationBlockFormThirdLabelCheck2">
                                    <input id="DepositCheck" type="checkbox" onChange={this.ChangeElementCheck1}/><label htmlFor="DepositCheck"></label>
                                    <div>{menuText.confirm_text[this.state.Language]} <a href="https://artyfact.game/terms" target="_blank">{menuText.terms[this.state.Language]}</a> & <a href="https://artyfact.game/privacy" target="_blank">{menuText.private[this.state.Language]}</a></div>
                                </div>
                                {/* <div className="VerificationBlockFormThirdLabelCheck VerificationBlockFormThirdLabelCheck2">
                                    <input id="DataCheck" type="checkbox" onChange={this.ChangeElementCheck2}/><label htmlFor="DataCheck"></label>
                                    <div><a href="https://artyfact.game/terms" target="_blank">Terms of Use*</a></div>
                                </div> */}
                                {/*disabled={loading || this.SignUpValidate()}*/}
                                {this.state.ButtonActiveBuy2 ? (
                                    <button type="submit" className="SignUpformSubmit">{menuText.registration[this.state.Language]}</button>
                                ) : (
                                    <button className="SignUpformSubmit" style={{backgroundColor: '#8e8e8e'}} disabled={true}>{menuText.registration[this.state.Language]}</button>
                                )}
                            </form>
                        )
                    }}

                </Mutation>

                <div class="text-center mt20px">
                    <a className="ForgotPass" href="https://artyfact.game/">{menuText.back_site[this.state.Language]}</a>
                </div>
            </div>
        )}}

export default withRouter(PageRegister)